var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Feed',_vm._b({attrs:{"item-id":_vm.itemId,"title":_vm.title,"order-by":"likes"}},'Feed',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }